import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
  overflow-x: hidden;
`;

const Layout = ({children}) => (
    <Wrapper>
      {children}
    </Wrapper>
);

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout.js